module.exports = __webpack_public_path__ + "static/media/part-11.946c4c10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-11.jpg
// module id = 944
// module chunks = 0